import React, {useState} from "react";
import {Button, Modal} from "react-bootstrap";
import {Form} from "semantic-ui-react";
import {L3Selector} from "../../../../common/network/NetworkSelectors";
import {CloneL3, L3Clone} from "../../../../services/NetworkApi";
import useAuth from "../../../login/AuthContext";
import {useNetworkContext} from "../../../../contexts/NetworkContext/context";

interface CloneRoomModalProps {
    show: boolean;
    onClose: () => void;
    l1Id: number;
    l2Id: number;
}


export const CloneRoomModal: React.FC<CloneRoomModalProps> = ({show, onClose, l1Id, l2Id}) => {
    const { loadNetworkInfoForNetworks } = useNetworkContext();
    const { getAuthToken } = useAuth();

    const [selections, setSelections] = useState<Partial<L3Clone>[]>([]);

    const onSubmit = () => {
        const clone = async () => {
            let valid = selections
                .filter(selection => selection.l3Id != null && selection.name != null)
                .map(selection => selection as L3Clone);

            if (valid.length == 0) {
                return;
            }

            await CloneL3(l1Id, l2Id, {requests: valid}, await getAuthToken());

            await loadNetworkInfoForNetworks([l1Id]);
            onClose();
        };
        clone();
    };

    const groups = selections.map((selection, index) => {
        return <Form.Group inline widths="equal">
            <Form.Field>
                <L3Selector l2Selection={l2Id} onSelectHandler={(x: any) => {selections[index].l3Id = x;}} />
            </Form.Field>
            <Form.Field>
                <Form.Input fluid label='Cloned L3 Name' placeholder='Cloned L3 Name'
                            onChange={(event, data) => {
                                selections[index].name = data.value;
                            }}
                />
            </Form.Field>
        </Form.Group>;
    });

    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Clone L3's</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form
                  onSubmit={onSubmit}
                >
                    {groups}
                    <Button onClick={() => setSelections([...selections, {}])} style={{ marginTop: "5px" }}>
                        Add More
                    </Button>
                    <br/>
                    <Button style={{ marginTop: "5px" }} type="submit">
                        Clone
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};